import { gql } from 'graphql-request';

const LINE_ITEM_FIELDS = `
  lineItemId
  description
  quantity
  unitOfMeasure
  amountSystem
  unitPrice
  salePricePerUnit
  cost
  salePrice
  chargeToClient
  discountType
  discountValue
  notes
  projectId
  organizationId
  createdAt
`;

const BUDGET_LINE_ITEM_FIELDS = `
  lineItemId
  description
  quantity
  unitOfMeasure
  amountSystem
  unitPrice
  salePricePerUnit
  cost
  salePrice
  chargeToClient
  discountType
  discountValue
  notes
  isOwnItem
  organizationName
`;

export const getProjectBudgetSummary = gql`
  query getProjectBudgetSummary($projectId: String!) {
    getProjectBudgetSummary(projectId: $projectId) {
      materials {
        materialId
        name
        supplier
        time
        amount
        amountType
        costPerUnit
        pricePerUnit
        taskId
        unitCost
        unitPrice
        totalCost
        totalPrice
        isOwnItem
        taskName
        originalProjectId
        originalOrganizationName
        unassigned
        chargeToClient
        displayOrganizationName
        source
      }
      equipments {
        equipmentId
        name
        supplierOwner
        time
        hoursUsed
        amount
        costPerHour
        pricePerHour
        taskId
        unitCost
        unitPrice
        totalCost
        totalPrice
        isOwnItem
        taskName
        originalProjectId
        originalOrganizationName
        unassigned
        chargeToClient
        displayOrganizationName
        source
      }
      lineItems {
        ${BUDGET_LINE_ITEM_FIELDS}
      }
      delegatedTaskCosts {
        taskId
        taskName
        organizationName
        budget
      }
      totalMaterialsCost
      totalEquipmentsCost
      totalLineItemsCost
      totalDelegatedCost
      totalAmount
    }
  }
`;

export const getDistinctLineItemUnitsOfMeasureQuery = gql`
  query getDistinctLineItemUnitsOfMeasure {
    getDistinctLineItemUnitsOfMeasure
  }
`;

export const createLineItemMutation = gql`
  mutation createLineItem($input: CreateLineItemInput!) {
    createLineItem(input: $input) {
      ${LINE_ITEM_FIELDS}
    }
  }
`;

export const updateLineItemMutation = gql`
  mutation updateLineItem($input: UpdateLineItemInput!) {
    updateLineItem(input: $input) {
      ${LINE_ITEM_FIELDS}
    }
  }
`;

export const deleteLineItemMutation = gql`
  mutation deleteLineItem($lineItemId: String!) {
    deleteLineItem(lineItemId: $lineItemId) {
      affected
    }
  }
`;

const LineItemGraphQL = {
  queries: {
    getProjectBudgetSummary,
    getDistinctLineItemUnitsOfMeasure: getDistinctLineItemUnitsOfMeasureQuery,
  },
  mutations: {
    createLineItem: createLineItemMutation,
    updateLineItem: updateLineItemMutation,
    deleteLineItem: deleteLineItemMutation,
  },
};

export default LineItemGraphQL;
